module.exports = __webpack_public_path__ + "img/Logo_blu_500.19acea56.png";